export enum MenuCategoryKeys {
  LEARNING_TOOLS = 'learningTools',
  TEST_PREP = 'TestPrep',
  CURRICULUM = 'curriculum',
  TOD = 'heading_Tutor',
  ENCYCLOPEDIA = 'Encyclopedia',
  STUDY_TIPS = 'Studytips',
  PEN_N_PAPER_EXERCISE = 'Pen&Paper',
  EXCEL_GEOGEBRA = 'excel&Geogebra',
  EXAMS = 'Exams',
  GAMES = 'games',
  JUNIOR_MATH = 'JuniorMath',
  MULT_MASTER = 'MultiplicationMaster',
  TREASURE_TRAIL = 'TreasureTrail',
  WIND_SURFER = 'WindSurfer',
  STACK_N_LOAD = 'Stackandload',
  PROFILE = 'profile',
  MASTERY_CERTIFICATES = 'MasteryCertificates',
  HOME = 'Home',
  PROGRESS = 'Progress',
  STUDENT_PANEL = 'Studentpanel',
  TEACHER_PANEL = 'Teacherpanel',
  TUTOR_PANEL = 'Tutorpanel',
  ADMIN_PANEL = 'Adminpanel',
  SETTINGS = 'Settings',
  REFERRAL = 'Referral',
  SUBSCRIPTION = 'Subscription',
  INVITE_FRIEND = 'InviteFriend',
  LANGUAGE = 'language',
  ENGLISH = 'en',
  NORSK = 'no',
  UKRAINIAN = 'uk',
}
